import { Box, CircularProgress } from '@mui/material';

export function LoadingSpinner(): JSX.Element {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="60vh"
    >
      <CircularProgress
        sx={(theme) => ({ color: theme.palette.secondary.main })}
        size={60}
      />
    </Box>
  );
}
